export type Application = {
  roles: AppRoles;
};

export type Role = {
  id?: number;
  name: string;
  displayName: string;
};

export type AppRoles = [AppRole];

export type AppRole = {
  id: number;
  name: string;
  displayName: string;
  description: string;
  responsibilities?: Responsibility[];
};

export type Responsibility = {
  responsibilityId: number;
  roleName: string;
  responsibleParty: ResponsibleParty;
};

export type ResponsibleParty = {
  __typename: string;
  firstName?: string;
  lastName?: string;
  login?: string;
  name?: string;
  email?: string;
  title?: string;
};

export enum ResourceIdentityType {
  User = 'USER',
  Group = 'GROUP',
}

export type CreateResponsibilityInput = {
  roleId: number;
  applicationId: number;
  identityId: string;
  identityType: ResourceIdentityType;
};

export type DeleteResponsibilityInput = {
  appId: number;
  responsibilityId: number;
};

export type UserRoleInfo = {
  roleId: number;
  displayName: string;
  description: string;
  responsibilityId: number;
};

export type UserRole = {
  roles: UserRoleInfo[];
  party: string;
};

export type UserRoles = [UserRole];

export enum RoleId {
  DataBusinessOwner = 159,
  DataLead = 205,
  FunctionalAreaRole = -2,
  Owner = -1,
}

export type RolesQueryVariables = {
  applicationId: number;
  filter: {
    policies: string[];
  };
};
